import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingAppointmentRoutingModule } from './pending-appointment-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { BdcSharedModule } from '../shared/bdc-shared.module';
import { PendingAppointmentComponent } from './pending-appointment.component';


@NgModule({
  declarations: [PendingAppointmentComponent],
  imports: [
    CommonModule,
    PendingAppointmentRoutingModule,
    SharedModule,
    BdcSharedModule
  ]
})
export class PendingAppointmentModule { }
